import { PurchaseConditionPrice } from '../../typings/product'
import { getPrioritizedPurchaseConditionsPrices } from './getPrioritizedPurchaseConditionsPrices'
import { normalizeProductPrice } from './normalizeProductPrice'

export const getCheapestPurchaseConditionPrice = (
  purchaseConditionsPrices: PurchaseConditionPrice[]
) => {
  const prioritizedByTakeAwayPurchaseConditionsPrices = getPrioritizedPurchaseConditionsPrices(
    purchaseConditionsPrices
  )

  if (!prioritizedByTakeAwayPurchaseConditionsPrices.length) {
    return null
  }

  return prioritizedByTakeAwayPurchaseConditionsPrices.reduce(
    (acc, current) => {
      if (
        normalizeProductPrice(current.price) < normalizeProductPrice(acc.price)
      ) {
        return current
      }

      return acc
    },
    prioritizedByTakeAwayPurchaseConditionsPrices[0]
  )
}
